import React from 'react';
import S from './styles';
import { TimetableItem } from "../timetable-item"

const timetableList = [
  {
    label: '13:00',
    title: '개회사',
    badge: ['위원회'],
  },
  {
    label: '13:20',
    title: '코딩테스트',
    speaker: 'Speaker ',
    badge: ['만도스'],
    slash: ' / ',
    supporter: 'Supporter ',
    supporterName: 'Rubin'
  },
  {
    label: '13:40',
    title: '프로그래밍 패러다임과 이를 통해 콤바인 바라보기',
    speaker: 'Speaker ',
    badge: ['수박'],
    slash: ' / ',
    supporter: 'Supporter ',
    supporterName: '태태'
  },
  {
    label: '14:00',
    title: '휴식 겸 아이스브레이킹',
    badge: ['위원회'],
  },
  {
    label: '14:20',
    title: 'Secret Session',
    badge: ['Anonymous'],
  },
  {
    label: '15:00',
    title: '네트워킹 및 기념사진 촬영',
    badge: ['위원회'],
  },
  {
    label: '15:50',
    title: 'swift playground 활용기',
    speaker: 'Speaker ',
    badge: ['RED'],
    slash: ' / ',
    supporter: 'Supporter ',
    supporterName: '에버(Ever)'
  },
  {
    label: '16:20',
    title: '애플워치 앱개발시 알아두면 좋을것들',
    speaker: 'Speaker ',
    badge: ['이준석'],
    slash: ' / ',
    supporter: 'Supporter ',
    supporterName: '태승'
  },
  {
    label: '16:40',
    title: '휴식',
    badge: ['위원회'],
  },
  {
    label: '16:50',
    title: 'CoreBluetooth로 1:1 채팅앱 만들어보기',
    speaker: 'Speaker ',
    badge: ['허성진(Lucas)'],
    slash: ' / ',
    supporter: 'Supporter ',
    supporterName: '클린트'
  },
  {
    label: '17:20',
    title: '폐회사 및 뒷풀이 안내',
    badge: ['위원회'],
  },
];

export const Timetable = () => (
  <S.Section>
    <S.Title
      id='timetable'
      data-sal="slide-up"
      data-sal-delay="100"
      data-sal-duration="600"
      data-sal-easing="ease"
    >
      TIMETABLE
    </S.Title>
    <S.Wrap>
      {timetableList.map((item, index) => (<TimetableItem item={item} index={index} key={item.title} />))}
    </S.Wrap>
  </S.Section>
)
